import React from 'react';

import { useSelector } from 'react-redux';

import { useState } from 'react';
import { refreshToken, toastNoti, EnableButton, DisableButton } from '../../utils/ConstUtils'

import axios from "axios";
import { baseUrl } from "../../config/config"

import {
  Button,
  Label,
  Modal,  
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';

import {
  AvForm,
  AvGroup,
  AvInput,
  AvFeedback
} from 'availity-reactstrap-validation';



const HeaderUserbox = () => {
  const loginDataStore = useSelector(state => state.loginReducer);
  const userLoginInfo = loginDataStore.data?.userLoginInfo || [];

  const [deleteModal, setDeleteModal] = useState(false);
  const toggleDeleteModal = () => { 
    setDeleteModal(!deleteModal);
  }
  
  const showDeleteModal = () => {
    toggleDeleteModal();
  };



  const [NowPassWord, SetNowPassWord] = useState("");
  const [NewPassWord, SetNewPassWord] = useState("");

  const processValidSubmit = () => {
    DisableButton("saveButton");

    let body = {
      email: userLoginInfo?.userAccount,
      password: NewPassWord,
      nowPassWord: NowPassWord
    };

    let httpHeaderInfo = {
      headers: {
        'Content-Type': 'application/json',
        'access_token': localStorage.getItem("accessToken")
      }
    };

    axios
      .post(baseUrl + "/admin/user/password/change", body, httpHeaderInfo)
      .then((res) => {
        if(res.data.status==="200") {
          toastNoti('비밀번호가 변경 되었습니다');
          toggleDeleteModal();
        } else if(res.data.status==="411") {
          refreshToken();
        } else {
          toastNoti(res.data.error);
        }
      })
      .catch(function (error) {
        toastNoti("서버와의 통신이 원활치 않습니다. 잠시 후 다시 시도해주세요.");
        if(error?.reponse?.error) toastNoti("오류 : " + error.reponse.error);
    });    

    setTimeout(function() {EnableButton("saveButton");}, 1000);
  };

  const throttle = (mainFunction, delay) => {
    let timerFlag = null;
    return (...args) => {
      if (timerFlag === null) {
        mainFunction(...args);
        timerFlag = setTimeout(() => {
          timerFlag = null;
        }, delay);
      }
    };
  }

  const throttleHandleValidSubmit = throttle(processValidSubmit, 10000);



  const handleInvalidSubmit = (event, errors, values) => {
    toastNoti('입력값 중에 오류가 있습니다. 다시 입력해주세요.');
  };

  const handleValidSubmit = () => {
    throttleHandleValidSubmit();
  };  



  return (
    <>
      <div className="d-none d-xl-block pl-2">
        <div className="font-weight-bold">
          {userLoginInfo?.userRole ? <>
              {userLoginInfo.userRole[0]?.authority==="ROLE_ADMIN" ? '학식 운영자 화면' : <>{userLoginInfo?.schoolName}</> } - {userLoginInfo?.userName} ({userLoginInfo?.userAccount})
          </> : ''}

          &nbsp;&nbsp;&nbsp;&nbsp;

          <Button size="sm" color="dark" onClick={showDeleteModal}>비밀번호 변경</Button>
        </div>
      </div>



      <Modal
          centered
          size="md"
          isOpen={deleteModal}
          zIndex={1300}
          scrollable={true}>
        <ModalHeader toggle={toggleDeleteModal}>비밀번호 변경</ModalHeader>
        <AvForm
          onValidSubmit={handleValidSubmit}
          onInvalidSubmit={handleInvalidSubmit}>
        <ModalBody>
          <AvGroup>
            <Label for="SetNowPassWord">현재 비밀번호 입력</Label>
            <AvInput type="password" name="SetNowPassWord" id="SetNowPassWord" placeholder="현재 비밀번호를 입력해주세요" validate={{
              minLength: {value: 6, errorMessage: '6자리 이상 입력해주세요'},
              maxLength: {value: 20, errorMessage: '20자리 이내로 입력해주세요'},
            }} 
            onChange={e => SetNowPassWord(e.target.value)} 
            value="" />
            <AvFeedback>현재 비밀번호를 입력해주세요</AvFeedback>
          </AvGroup>          
          <AvGroup>
            <Label for="SetNewPassWord">새 비밀번호 (6자리 이상 입력)</Label>
            <AvInput type="password" name="SetNewPassWord" id="SetNewPassWord" placeholder="새 비밀번호를 입력해주세요" validate={{
              minLength: {value: 6, errorMessage: '6자리 이상 입력해주세요'},
              maxLength: {value: 20, errorMessage: '20자리 이내로 입력해주세요'},
            }} 
            onChange={e => SetNewPassWord(e.target.value)} 
            value="" />
            <AvFeedback>새 비밀번호를 입력해주세요</AvFeedback>
          </AvGroup>
          <AvGroup>
            <Label for="ConfirmNewPassWord">새 비밀번호 확인</Label>
            <AvInput type="password" name="ConfirmNewPassWord" id="ConfirmNewPassWord" placeholder="새 비밀번호를 동일하게 한번 더 입력해주세요" validate={{match:{value:'SetNewPassWord'}}} required 
            value="" />
            <AvFeedback>새 비밀번호를 동일하게 한번 더 입력해주세요</AvFeedback>
          </AvGroup>
        </ModalBody>
        <ModalFooter>
          <div className="form-row">
            <div className="form-group col-md-12 align-items-center">                        
            </div>
            <div className="form-group col-md-12 align-items-center">                        
              <div className="d-flex justify-content-end">
                <Button name="saveButton" size="sm" color="danger">비밀번호 변경</Button>&nbsp;&nbsp;&nbsp;
                <Button size="sm" color="dark" onClick={toggleDeleteModal}>취소</Button>
              </div>
            </div>
          </div>
        </ModalFooter>
        </AvForm>
      </Modal>          
    </>
  );
};

export default HeaderUserbox;



